export const clickableWrapperDiameter = '49px';
